import { render, staticRenderFns } from "./ReviewDomain.vue?vue&type=template&id=e7131188&scoped=true"
import script from "./ReviewDomain.vue?vue&type=script&lang=js"
export * from "./ReviewDomain.vue?vue&type=script&lang=js"
import style0 from "./ReviewDomain.vue?vue&type=style&index=0&id=e7131188&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7131188",
  null
  
)

export default component.exports